export default __webpack_public_path__ + "static/media/menu.b07f8960.png";